import React, { useEffect, useState } from "react";
import localizationService from "../../services/localization-service.js";
import { useSelector } from "react-redux";

const ConfirmationModal = ({ isOpen, onClose, title, text1, text2, text3 }) => {
  const selectedlang = useSelector((state) => state.account.lang);
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 1300) {
      setIsDesktopResolution(false);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 relative">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>

          <i
            className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
            onClick={onClose}
          ></i>
        </div>

        {/* Body */}
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500 mb-3">{text1}</p>
          <p
            className={`text-sm text-gray-500 ${text3 !== "" && text3 !== null && text3 !== undefined ? "mb-3" : ""}`}
          >
            {text2}
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={onClose}
            className={`inline-flex items-center justify-center ${!isDesktopResolution ? "w-[100%]" : "w-[70%]"} 
              px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:!bg-gray-50 focus:outline-none focus:ring-2 
              focus:ring-offset-2 focus:ring-gray-200`}
          >
            {localizationService.getLocalizationValue("ok", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
